export default __webpack_public_path__ + "static/media/512.9c8255b3.png";